// @flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import OverlayDialog from 'common/components/core/dialog/OverlayDialog';
import { Button, ButtonTypes } from 'common/components/core/button';

import defaultTheme from './SingleEntityEditView.scss';

type Props = {
    theme: Object,
    entityName: string,
    isEditing: boolean,
    onDismiss: () => void,
    children: React.Node
};

class SingleEntityEditView extends React.Component<Props> {
    renderTitle() {
        const { theme, isEditing, entityName } = this.props;
        const titleText = isEditing
            ? `Edit ${entityName}`
            : `Add New ${entityName}`;
        return (
            <div className={theme.titleSection}>
                <span className={theme.title}>{titleText}</span>
            </div>
        );
    }

    render() {
        const { theme, onDismiss, children } = this.props;
        let ContentChildren = null;
        let ModalChildren = null;
        let otherChildren = [];
        if (children) {
            if (children instanceof Array) {
                children.forEach(child => {
                    if (child) {
                        if (child.type === Content) {
                            ContentChildren = child.props.children;
                            return;
                        }
                        if (child.type === ThemedModal) {
                            ModalChildren = child;
                            return;
                        }
                        otherChildren = [
                            ...(otherChildren ? otherChildren : []),
                            child
                        ];
                    }
                });
            }

            if (!ContentChildren) {
                if (children.type === Content) {
                    ContentChildren = children.props.children;
                } else {
                    ContentChildren = children;
                }
            }
        }
        return (
            <OverlayDialog
                active
                className={theme.overlay}
                dialogClassName={theme.dialog}
            >
                <div className={theme.outerContainer}>
                    <Button
                        buttonType={ButtonTypes.Icon}
                        circle
                        icon="cancel"
                        className={theme.closeBtn}
                        theme={theme}
                        onClick={onDismiss}
                    />
                    <div className={theme.container}>
                        {ModalChildren}
                        {this.renderTitle()}
                        {ContentChildren}
                        {otherChildren}
                    </div>
                </div>
            </OverlayDialog>
        );
    }
}

export const Content = () => null;
const Modal = ({ theme, children }) => {
    if (!children) {
        return null;
    }
    if (children instanceof Array) {
        const relevantChildren = children.filter(child => !!child);
        if (relevantChildren.length === 0) {
            return null;
        }
    }
    return (
        <OverlayDialog className={theme.modalOverlay} theme={theme} active>
            {children}
        </OverlayDialog>
    );
};

const ThemedModal = themr(null, defaultTheme)(Modal);

const Section = ({ theme, children, className }) => {
    return (
        <div
            className={classnames(theme.section, { [className]: !!className })}
        >
            {children}
        </div>
    );
};

const ThemedSection = themr(null, defaultTheme)(Section);

export { ThemedModal as Modal, ThemedSection as Section };

export default themr(null, defaultTheme)(SingleEntityEditView);
